export default (callSign: string) => {
  const snippet =
    `ra(function() {
        var tracker = ra.createExternalTracker("${callSign}");
        var audio = document.getElementById("player");

        if(audio.paused !== true) {
          tracker.playStarted();
        }

        audio.onplay = function() {
          tracker.playStarted();
        };

        audio.onpause = function () {
          tracker.playStopped();
        };
      });`;

  return snippet;
};



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/content/radioAnalytics/snippets/externalTrackerSnippet.js